import { render, staticRenderFns } from "./ServiceColUser.vue?vue&type=template&id=71352903&"
import script from "./ServiceColUser.vue?vue&type=script&lang=js&"
export * from "./ServiceColUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports